import { UrlConstants } from "../url.constants";
export class ApiUserConstants {
    static URL = UrlConstants.API_V2 + "User";
    static FUNCTION_DELINK_MODULE_ROLE = "DelinkModuleRole";
    static FUNCTION_DELINK_SYSTEM_ROLE = "DelinkSystemRole";
    static FUNCTION_LINK_MODULE_ROLE = "LinkModuleRole";
    static FUNCTION_LINK_SYSTEM_ROLE = "LinkSystemRole";
    static FUNCTION_ACCEPT_DISCLAIMER = "AcceptDisclaimer";
    static FUNCTION_GET_MY_MODULE_ROLES = "GetMyModuleRoles";
    static FUNCTION_GET_MY_INFORMATION = "GetMyInformation";
    static FUNCTION_GET_MY_ORGANISATION_ROLES = "GetMyOrganisationRoles";
    static FUNCTION_GET_PORTAL_USERS_WITH_APPLICATIONS = "GetPortalUsersWithApplications";
    static FUNCTION_GET_PORTAL_USERS = "GetPortalUsers";
    static FUNCTION_UPLOAD_SIGNATURE = "UploadSignature";
    static FUNCTION_GET_SIGNATURE_CONTENT_BASE64 = "GetSignatureContentBase64";
}
